import DnDWrapper from './DnDWrapper'

export default DnDWrapper
